import { FaGithub, FaLinkedinIn, FaYoutube, FaEnvelope } from 'react-icons/fa'

const socials = [
  { href: 'https://github.com/bellhwi', label: 'GitHub', Icon: FaGithub },
  { href: 'https://www.linkedin.com/in/jonghwikim/', label: 'LinkedIn', Icon: FaLinkedinIn },
  { href: 'https://www.youtube.com/@jonghwikim', label: 'YouTube', Icon: FaYoutube },
  { href: 'mailto:johnnykim94@hotmail.com', label: 'Email', Icon: FaEnvelope },
]

function Footer() {
  return (
    <footer className='flex justify-center lg:justify-start items-center space-x-3 text-gray-400 pb-10 pt-8 lg:p-0'>
      {socials.map(({ href, label, Icon }) => (
        <a
          key={label}
          href={href}
          aria-label={label}
          className='hover:text-black'
          {...(href.startsWith('http')
            ? { target: '_blank', rel: 'noreferrer noopener' }
            : {})}
        >
          <Icon />
        </a>
      ))}
    </footer>
  )
}

export default Footer
